module.exports = __webpack_public_path__ + "static/media/step2img3.112f238d.jpg";